import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ng6-toastr-notifications';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from '../home/home.component';
import { GestioneUtentiComponent } from '../gestione-utenti/gestione-utenti.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerDataEntryComponent } from '../customer-data-entry/customer-data-entry.component';
import { NgWizardConfig, NgWizardModule, THEME } from 'ng-wizard';
import { CreazioneNuovoCustomerComponent } from '../customer-data-entry/save/creazione-nuovo-customer/creazione-nuovo-customer.component';
import { CustomerCountryComponent } from '../customer-data-entry/save/customer-country/customer-country.component';
import { CustomerAffiliateComponent } from '../customer-data-entry/save/customer-affiliate/customer-affiliate.component';
import { CustomerDepartmentComponent } from '../customer-data-entry/save/customer-department/customer-department.component';
import { ModificaCustomerComponent } from '../customer-data-entry/save/modifica-customer/modifica-customer.component';
import { LocalAgreementsViewComponent } from '../local-agreements/local-agreements-view/local-agreements-view.component';
import { CustomerBoperatorComponent } from '../customer-data-entry/save/customer-boperator/customer-boperator.component';
import { CustomerLeadoperatorComponent } from '../customer-data-entry/save/customer-leadoperator/customer-leadoperator.component';
import { CatalogViewComponent } from '../catalog-view/catalog-view.component';
import { HandsetViewComponent } from '../catalog-view/handset-view/handset-view.component';
import { TariffAndOptionViewComponent } from '../catalog-view/tariff-and-option-view/tariff-and-option-view.component';
import { ButtonsCatalogViewComponent } from '../catalog-view/buttons-catalog-view/buttons-catalog-view.component';
import { BundledProductOfferingViewComponent } from '../catalog-view/bundled-product-offering-view/bundled-product-offering-view.component';
import { InventoryViewComponent } from '../inventory-view/inventory-view.component';
import { ProductRelationShipViewComponent } from '../inventory-view/product-relation-ship-view/product-relation-ship-view.component';
import { ReportingViewComponent } from '../reporting-view/reporting-view.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FilterViewComponent } from '../reporting-view/filter-view/filter-view/filter-view.component';
import { OverviewReportComponent } from '../reporting-view/report-view/overview-report/overview-report.component';
import { ChartsModule } from 'ng2-charts';
import 'chartjs-plugin-labels';
import { OrderDetailComponent } from '../reporting-view/report-view/order-detail/order-detail.component';
import { SlaKpisComponent } from '../reporting-view/report-view/sla-kpis/sla-kpis.component';
import { CompletedDetailComponent } from '../reporting-view/report-view/completed-detail/completed-detail.component';
import { SlaRespectedViewComponent } from '../reporting-view/report-view/sla-respected-view/sla-respected-view.component';



const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};

@NgModule({
  declarations: [
    HomeComponent,
    GestioneUtentiComponent,
    CustomerDataEntryComponent,
    CreazioneNuovoCustomerComponent,
    ModificaCustomerComponent,
    CustomerCountryComponent,
    CustomerAffiliateComponent,
    CustomerDepartmentComponent,
    LocalAgreementsViewComponent,
    CustomerBoperatorComponent,
    CustomerLeadoperatorComponent,
    CatalogViewComponent,
    HandsetViewComponent,
    TariffAndOptionViewComponent,
    ButtonsCatalogViewComponent,
    BundledProductOfferingViewComponent,
    InventoryViewComponent,
    ProductRelationShipViewComponent,
    FilterViewComponent,
    OverviewReportComponent,
    ReportingViewComponent,
    OrderDetailComponent,
    SlaKpisComponent,
    CompletedDetailComponent,
    SlaRespectedViewComponent,
    LayoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    Ng2SmartTableModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule ,
    ToastrModule.forRoot(),
    NgWizardModule.forRoot(ngWizardConfig),
    NgMultiSelectDropDownModule,
    ChartsModule
   
      ],
  exports: [NgbModule]
})
export class LayoutModule { }
